var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoProgressBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.5C11.5822 18.5 13.129 18.0308 14.4446 17.1518C15.7602 16.2727 16.7855 15.0233 17.391 13.5615C17.9965 12.0997 18.155 10.4911 17.8463 8.93928C17.5376 7.38743 16.7757 5.96197 15.6569 4.84315C14.538 3.72433 13.1126 2.9624 11.5607 2.65372C10.0089 2.34504 8.40034 2.50347 6.93853 3.10897C5.47672 3.71447 4.2273 4.73985 3.34824 6.05544C2.46919 7.37103 2 8.91775 2 10.5",
    stroke: "url(#paint0_linear_65_9938)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_9938",
    x1: 16.6206,
    y1: 17.5,
    x2: -3.8794,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#3483FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#3483FA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProgressBlue);
export default __webpack_public_path__ + "static/media/ico-progress-blue.d5e00c0177f15b9f49c079a2f910f515.svg";
export { ForwardRef as ReactComponent };